import { OptionsApi } from '@core/swagger-client';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../Button';
import { Heading } from '../Heading';
import { WarningOutlined } from '../Icons/WarningOutlined';

export const AccountVerificationRequired = () => {
    const { t } = useTranslation();
    const [sendState, setSendState] = useState<'not-sent' | 'success' | 'error'>('not-sent');

    const resendVerificationEmailMutation = useMutation(OptionsApi.account.resendVerificationEmail());
    const sendVerificationEmail = () => {
        resendVerificationEmailMutation.mutate(undefined, {
            onSuccess: () => {
                setSendState('success');
            },
            onError: () => {
                setSendState('error');
            }
        });
    };

    return (
        <div className="bg-white bg-side-warning bg-no-repeat rounded-lg flex flex-col items-start gap-1 pl-6 md:pl-8 pr-4 md:pr-6 pt-4 pb-6 z-10">
            <WarningOutlined classNames="w-10 fill-warning mb-2" />
            <Heading variant="h3">{t('Account.Verification.Required.Title')}</Heading>
            {sendState === 'not-sent' && (
                <>
                    <p className="max-w-3xl mb-4">{t('Account.Verification.Required.Body')}</p>
                    <Button onClick={sendVerificationEmail} variant="primary" isLoading={resendVerificationEmailMutation.isPending}>
                        {t('Account.Verification.Required.Button')}
                    </Button>
                </>
            )}
            {sendState === 'success' && <p className="max-w-3xl">{t('Account.Verification.Required.Success')}</p>}
            {sendState === 'error' && <p className="max-w-3xl">{t('Account.Verification.Required.Error')}</p>}
        </div>
    );
};
